module.exports = __webpack_public_path__ + "static/media/my_turn4.9b5c754a.mp3";